export default __webpack_public_path__ + "static/media/SwimAlone_productions.922dee64.jpg";